// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component } from '@angular/core';
import { HeaderService } from '../../../header.service';
import { BehaviorSubject } from 'rxjs';
import { ALL_ORGS_ID } from '../../../../types/group';

@Component({
    selector: 'app-top-threats',
    templateUrl: './top-threats.component.html',
    styleUrls: ['./top-threats.component.scss'],
    standalone: false
})
export class TopThreatsComponent {
  selectedOrgId$: BehaviorSubject<string> = new BehaviorSubject<string>(ALL_ORGS_ID);
  timeInterval: string = "336h"

  constructor(private headerService: HeaderService) {
    this.selectedOrgId$ = this.headerService.orgSelectedChanged;
  }

}
